import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";

/**
 * DS ImageSlot — figma 273:261 "Frame 40" (이미지 추가 빈 슬롯) + 269:251 "image" (업로드된 이미지)
 *
 * 빈 슬롯: white bg, border 1px default, radius 6, 140×140
 *   - 중앙: + 아이콘(24×24) + "이미지 추가" (Pretendard SemiBold 14/22 Tertiary)
 *
 * 채워진 슬롯: BG/Paper-Dark, radius 6
 *   - 좌상단 "대표" 배지 (BG/Black, padding 8×2, Inverse 12/18 SemiBold)
 *   - 우상단 삭제 버튼 (rgba(black,0.5) 16×16, X 아이콘 14×14)
 *
 * @param {object} props
 * @param {string} [props.imageUrl] - 채워진 경우의 src
 * @param {React.ReactNode} [props.image] - S3Image 등 직접 ReactNode
 * @param {boolean} [props.isRepresentative] - "대표" 배지 표시
 * @param {() => void} [props.onAdd] - 빈 슬롯 클릭
 * @param {() => void} [props.onDelete] - 채워진 슬롯 삭제 클릭
 */
const DSImageSlot = ({
  imageUrl,
  image,
  isRepresentative = false,
  onAdd,
  onDelete,
}) => {
  const filled = !!(imageUrl || image);

  if (!filled) {
    return (
      <button type="button" className="ds-image-slot ds-image-slot--empty" onClick={onAdd}>
        <span className="ds-image-slot__add">
          <FontAwesomeIcon icon={faPlus} className="ds-image-slot__add-icon" />
          <span className="ds-image-slot__add-text">이미지 추가</span>
        </span>
      </button>
    );
  }

  return (
    <div className="ds-image-slot ds-image-slot--filled">
      {image || (imageUrl && <img src={imageUrl} alt="" className="ds-image-slot__img" />)}
      {/* figma 298:4789 — 이미지 위 검은 dimmed overlay (디자이너 코멘트: 기본적으로 이미지 추가되면 이미지 위로 딤드 들어갑니다) */}
      <span className="ds-image-slot__dimmed" aria-hidden />
      {isRepresentative && <span className="ds-image-slot__badge">대표</span>}
      {onDelete && (
        <button
          type="button"
          className="ds-image-slot__delete"
          onClick={onDelete}
          aria-label="삭제"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      )}
    </div>
  );
};

export default React.memo(DSImageSlot);
